import React from 'react';

import Stats from './Stats';

const StatPageContainer = props => <Stats {...props} />;

export default StatPageContainer;
